<template>
    <b-row class="pb-4" v-if="getSelectionGroups.length > 1">
        <b-col>
            <b-button
                v-for="(group, groupindex) in getSelectionGroups"
                :active="getSelectionObjectsSelectedGroup === group"
                :key="`group_button_${group.id}`"
                @click="
                    updateSelectionPointer({ group: groupindex, index: -1 })
                "
                >{{ group.title }} <span>({{ group.count }})</span></b-button
            >
        </b-col>
    </b-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'getSelectionGroups',
                'getSelectionObjectsSelectedGroup'
            ])
        },
        methods: { ...mapActions(['updateSelectionPointer']) }
    };
</script>
